import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "33",
  height: "16",
  viewBox: "0 0 33 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "32",
  height: "4",
  rx: "2",
  transform: "matrix(-1 0 0 1 32.0566 0)",
  fill: "#367DE9"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  width: "23.8455",
  height: "4",
  rx: "2",
  transform: "matrix(-1 0 0 1 23.9023 12)",
  fill: "#367DE9"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }